import React from 'react'
import { DashboardLayout } from '../layouts'
import { FormContainer, FormsTopbar } from '../containers'
import { useState } from 'react'

function Forms() {

    const [selectedAgents, setSelectedAgents] = useState([])

    return (
        <DashboardLayout>
            <div className="flex flex-col gap-5">
               <FormsTopbar selectedAgents={selectedAgents} setSelectedAgents={setSelectedAgents} />
                <div>
                    <FormContainer />
                </div>
            </div>
        </DashboardLayout>
    )
}

export default Forms